<template>
  <a-spin :spinning="loading">
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="容器出库" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-cell-group>
      <van-field ref="barcode" v-model="containerNumber" autofocus clearable label="容器个数" />
    </van-cell-group>
    <van-cell-group>
      <van-field :value="containerType.name" clickable label="容器类型" name="containerTypePicker" readonly @click="showContainerType=true" />
      <van-popup v-model="showContainerType" position="bottom">
        <van-picker :columns="containerTypes" show-toolbar value-key="name" @cancel="showContainerType=false" @confirm="onContainerTypeSelected" />
      </van-popup>
    </van-cell-group>
    <van-cell-group>
      <van-field :value="address.name" clickable label="补给点" name="addressPicker" readonly @click="showAddress=true" />
      <van-popup v-model="showAddress" position="bottom">
        <van-picker :columns="addresses" show-toolbar value-key="name" @cancel="showAddress=false" @confirm="onAddressSelected" />
      </van-popup>
    </van-cell-group>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-button block round style="margin: 8px; width: 100%" type="primary" @click="confirm">确认</van-button>
      </van-tabbar-item>
    </van-tabbar>
  </a-spin>
</template>
<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { getUser } from '@/pdaView/utils'
import { Dialog } from 'vant'

export default {
    data() {
      return {
        loading: false,
        username: getUser().name,
        containerNumber: 1,
        containerType: { id: null, no: '', name: '' },
        address: { id: null, name: '' },
        containerTypes: [],
        addresses: [],
        showContainerType: false,
        showAddress: false
      }
    },
    created() {
      this.getContainerTypes()
      this.getAddresses()
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.back()
      },
      getContainerTypes() {
        findAll('containerTypeFactory', { 'physical': true }).then(res => {
          if (res.success && res.result.length > 0) {
            this.containerTypes = res.result.map(row => {
              return { id: row.id, no: row.no, name: row.name }
            })
          }
        })
      },
      onContainerTypeSelected(item) {
        this.containerType = item
        this.showContainerType = false
      },
      getAddresses() {
        findAll('addressFactory', { 'customer.no': 'KRQ' }).then(res => {
          if (res.success && res.result.length > 0) {
            this.addresses = res.result.map(row => {
              return { id: row.id, name: row.addressInfo.detailAddress }
            })
          }
        })
      },
      onAddressSelected(item) {
        this.address = item
        this.showAddress = false
      },
      confirm() {
        if (this.containerType.id === null) {
          Dialog({ message: '请先选择容器类型' })
          return
        }
        if (this.address.id === null) {
          Dialog({ message: '请选择补给点' })
          return
        }
        this.loading = true
        const args = {
          'address.id': this.address.id,
          'item.no': this.containerType.no,
          'quantity': this.containerNumber
        }
        post(api.containerSupply, { type: 'generalHandler' }, args).then(res => {
          if (res.success) {
            Dialog({ message: '确认成功' })
          }
        }).finally(() => this.loading = false)
      }
    }
  }
</script>